

<template>
    <div class="sustainable-component competence-employee-multiskill">
        <!--<div class="bg-success mb-3 p-3 rounded">vue component competence-employee-multiskill</div>-->

        <div class="container-fluid p-0">
            <div class="row">
                <div class="col-6">
                    <v-select bg-color="white" variant="outlined" v-bind:label="$t('general.workorganisation_general_position')" :items="internalModel.JobPositions" v-model="selectedPosition" item-title="Name" item-value="JobPositionId"></v-select>
                </div>
                <div class="col-6">
                    <v-select bg-color="white" variant="outlined" label="Befattning (mångkunnighet)" :items="filterItems(internalModel.JobPositions)" v-model="selectedMultiskillPosition" item-title="Name" item-value="JobPositionId"></v-select>
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-md-5">
                    <table class="table table-light table-hover table-striped" cellspacing="0" cellpadding="8" border="0" style="border-collapse:collapse">
                        <thead>
                            <tr>
                                <th class="col-2">Anst.nr.</th>
                                <th class="col-4">Förnamn</th>
                                <th class="col-5">Efternamn</th>
                                <th class="col-1"></th>
                            </tr>
                        </thead>
                        <tbody>

                            <tr v-for="(item, index) in employees" :key="index">
                                <td>
                                    <span v-if="item.EmployeeId == selectedEmployee"><b>{{item.EmployeeNumber}}</b></span>
                                    <span v-if="item.EmployeeId != selectedEmployee">{{item.EmployeeNumber}}</span>
                                </td>
                                <td>
                                    <span v-if="item.EmployeeId == selectedEmployee"><b>{{item.FirstName}}</b></span>
                                    <span v-if="item.EmployeeId != selectedEmployee">{{item.FirstName}}</span>
                                </td>
                                <td>
                                    <span v-if="item.EmployeeId == selectedEmployee"><b>{{item.LastName}}</b></span>
                                    <span v-if="item.EmployeeId != selectedEmployee">{{item.LastName}}</span>
                                </td>
                                <td>
                                    <span v-if="item.EmployeeId == selectedEmployee"><b>Vald</b></span>
                                    <a v-if="item.EmployeeId != selectedEmployee" href="javascript:void(0)" @click="selectEmployee(item.EmployeeId)">välj</a>
                                </td>

                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="col-12 col-md-7">



                    <table class="table table-light table-hover table-striped" cellspacing="0" cellpadding="8" border="0" style="border-collapse:collapse">
                        <thead>
                            <tr>
                                <th class="col-1">BlockNr.</th>
                                <th class="col-4">BlockNamn</th>
                                <th class="col-2">Godkänd</th>

                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="selectedPosition != null && selectedEmployee == null">
                                <td colspan="3">Välj en anställd</td>
                            </tr>
                            <tr v-if="selectedPosition != null && selectedEmployee != null && selectedMultiskillPosition == null">
                                <td colspan="3">Välj en mångkunnighetsbefattning</td>
                            </tr>
                            <tr v-for="(item, index) in multiskills" :key="index">
                                <td>
                                    <span>{{item.BlockNumber}}</span>
                                </td>
                                <td>
                                    <span>{{item.BlockName}}</span>
                                </td>
                                <td>
                                    <span>
                                        <v-checkbox v-bind:disabled="disabled" density="compact" v-model="item.Passed" hide-details></v-checkbox>
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <v-btn v-bind:disabled="disabled" v-if="multiskills.length > 0" size="default" color="primary" class="btn-primary" @click="updateEmployeeMultiskill">
                        Uppdatera
                    </v-btn>

                </div>
            </div>
        </div>
        <v-snackbar :timeout="2000" v-model="showSnackBar" color="success">
            {{snackbarMessage}}
        </v-snackbar>
        <v-snackbar :timeout="2000" v-model="showErrorMessageSnackBar" color="error">
            {{errorMessage}}
        </v-snackbar>
        <common-spinner v-bind:loading="loading > 0"></common-spinner>
    </div>
</template>


<script>

    import WageService from "../../Services/WageService";
    import CompetenceService from "../../Services/CompetenceService";
    import CommonSpinner from '../../common/common-spinner.vue'
    import { getCurrentInstance } from 'vue'

    export default {

        name: 'competence-employee-multiskill',
        props: {
            model: Object,
            selectedJobPosition: String,
            disabled: {
                type: Boolean,
                required: false,
                default: false,
            },
        },
        components: {
            CommonSpinner,
        },
        methods: {
            async updateEmployeeMultiskill() {
                this.loading++;
                try {
                    await CompetenceService.saveEmployeeMultiskill(this.selectedEmployee, this.multiskills);
                    this.displaySnackBar("Sparat");
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat")
                }
                this.loading--;
            },
            getId() {
                return getCurrentInstance().uid;
            },
            async getEmployeesFromJobPosition(selectedPosition) {
                this.loading++;
                try {
                    this.employees = await WageService.getEmployeesFromJobPosition(selectedPosition);
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            async selectEmployee(employeeId) {
                this.loading++;
                this.selectedEmployee = employeeId;
                try {
                    this.competencies = await CompetenceService.getEmployeeMultiskill(employeeId, this.selectedMultiskillPosition);
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            filterItems(positions) {
                var filtered = [];
                for (var i = 0; i < positions.length; i++) {
                    if (positions[i].JobPositionId != this.selectedPosition) {
                        filtered.push(positions[i]);
                    }
                }
                return filtered;
            },
            async getEmployeeMultiskill(selectedMultiskillPosition) {
                this.loading++;
                try {
                    this.multiskills = await CompetenceService.getEmployeeMultiskill(this.selectedEmployee, selectedMultiskillPosition);
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            displaySnackBar(message) {
                this.snackbarMessage = message;
                this.showSnackBar = true;
            },
            displayErrorSnackBar(message) {
                this.errorMessage = message;
                this.showErrorMessageSnackBar = true;
            },
        },

        data() {
            return {
                competencies: [],
                selectedEmployee: null,
                multiskills:[],
                employees: [],
                selectedPosition: null,
                selectedMultiskillPosition: null,
                selected: {},
                step: 1,
                internalModel: {
                    JobPositions: [],
                    BlockGrades: [],
                    WageFactorGrades: [],
                    WageFactors: [],
                },
                newWindow: {},
                loading: 0,
                showSnackBar: false,
                snackbarMessage: null,
                showErrorMessageSnackBar: false,
                errorMessage: null,
            };
        },
        watch: {
            selectedEmployee: function (newVal) {
                if (newVal != null && this.selectedMultiskillPosition != null) {
                    this.getEmployeeMultiskill(this.selectedMultiskillPosition)
                }
            },
            selectedPosition: function (newVal) {
                this.selectedMultiskillPosition = null;
                this.selectedEmployee = null;
                this.multiskills = [];
                this.getEmployeesFromJobPosition(newVal);
                this.$emit('positionSelected', newVal)
            },
            selectedMultiskillPosition: function (newVal) {
                if(newVal != null)
                    this.getEmployeeMultiskill(newVal)
            },
        },
        mounted() {
            this.internalModel = this.model;
            this.selectedPosition = this.selectedJobPosition;
            if (this.internalModel.JobPositions.length > 0 && this.selectedJobPosition == null) {
                this.selectedPosition = this.internalModel.JobPositions[0].JobPositionId;
            }
        },
        setup () {
            //const workDialog = ref()
            //return { workDialog }
            return {};
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
